import CommonLock from '@op/components/CommonLock';
import ContentBody from '@op/components/ContentBody';
import React from 'react';
import { Layout } from 'tea-component';
const { Content } = Layout;
export default function Lock() {
  return (
    <Content className="dbo-page">
      <ContentBody>
        <CommonLock></CommonLock>
      </ContentBody>
    </Content>
  );
}
